<!-- Page content -->
<div class="container pb-5 bg-light">
  <div class="row justify-content-center">

    <div class="mt-5 text-center col-12">
      <h2 class="text-danger m-4">Ação não permitida.</h2>
      <h5>{{textoErro}}</h5>
    </div>

    <div class="text-center col-6 mt-5 p-2">
    <!--  <button type="submit" class="btn btn-outline-warning btn-lg btn-block p-3" (click)="atualizar()">
        <i class="fas fa-sync mr-2"></i>Atualizar
      </button>
    -->
    </div>
  </div>
</div>
